import React, { useEffect } from 'react';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';
import RetencionesMasivasTicketsRenderStatus from '../components/RetencionesMasivasTicketsRenderStatus';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.list;
};

const mapActions = (actions) => {
  return { ...actions.modulo.retenciones_masivas.tickets.list };
};

const RetencionesMasivasTicketsList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      paginate({ page: 1 });
    }
  }, []); // eslint-disable-line

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const paginate = (meta) => {
    actions.paginate({ pagination: meta });
  };

  const getPaginationConfig = () => {
    return {
      metadata: state.pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      onRowClick={props.onRowClick}
      onRow={onRowRender}
      pagination={getPaginationConfig()}
      rowSelection={getRowSelectionConfig()}
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'fecha',
    title: 'Fecha Retención',
    dataIndex: 'fecha',
    className: 'cell-medium',
  },
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
    className: 'cell-medium',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'receptor_rfc',
    title: 'Receptor',
    dataIndex: 'receptor_rfc',
  },
  {
    key: 'receptor_razon_social',
    title: 'Razon social',
    dataIndex: 'receptor_razon_social',
    align: 'left',
    className: 'cell-large',
  },
  {
    key: 'receptor_nacionalidad',
    title: 'Nacionalidad',
    dataIndex: 'receptor_nacionalidad',
    align: 'left',
  },
  {
    key: 'mes_ini',
    title: 'Mes inicial',
    dataIndex: 'mes_ini',
    align: 'center',
  },
  {
    key: 'mes_fin',
    title: 'Mes final',
    dataIndex: 'mes_fin',
    align: 'center',
  },
  {
    key: 'ejercicio',
    title: 'Ejercicio',
    dataIndex: 'ejercicio',
    align: 'center',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
    align: 'center',
    className: 'cell-xxlarge',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <RetencionesMasivasTicketsRenderStatus item={item} />,
  },
];

export default RetencionesMasivasTicketsList;
